// import Spinner from "react-bootstrap/Spinner";

const SpinnerLoading = (color) => {
  if (!color) color = "green";
  return <span>Loaidng...</span>;
};

export default SpinnerLoading;
